import type { Ref } from 'vue';
import { computed } from 'vue';

import type { ITranslationsKeyMap } from '@modules/i18n/types';

export function getTranslationKeys(): Ref<ITranslationsKeyMap> {
  return computed(() => ({
    admin: {
      settings: {
        general_settings: {
          merchant_settings: {
            edit: {
              header: 'HEADER',
              form: {
                merchant_name: 'MERCHANT_NAME_LABEL',
                header_color: 'HEADER_COLOR_LABEL',
                buttons_color: 'BUTTONS_COLOR_LABEL',
                logo: 'LOGO_LABEL',
                preview: 'PREVIEW',
                preview_enabled: 'PREVIEW_ENABLED',
                preview_disabled: 'PREVIEW_DISABLED',
                preview_description: 'PREVIEW_DESCRIPTION',
              },
              submit: 'SUBMIT',
              show_current_logo: 'SHOW_CURRENT_LOGO',
              back: 'BACK',
            },
          },
        },
      },
    },
  }));
}
